const getDomain = (): string => {
  if (process.env.REACT_APP_ENV === "production")
    return "https://builder.guidebook.com/"
  else if (process.env.REACT_APP_ENV === "staging")
    return "https://beta.guidebook.com/"
  else if (process.env.REACT_APP_ENV === "dev")
    return `https://${process.env.REACT_APP_DEV_ENV}.guidebookdev.com/`
  else return "http://localhost/"
}

export { getDomain }
